import resolveSeatColors from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/resolveSeatColors';
import { getClosestConfigurationFromGeneralAdmission } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import { GENERAL_ADMISSION_FILL } from '%paysera_seat_selection/js/seatSelection/config/defaults';

export default ({ TicketType, Seat, GeneralAdmission }, { payload }) => {
    const { hash } = payload;

    const ticketType = TicketType.all().filter({ hash }).first();

    if (!ticketType) {
        return;
    }
    const seats = ticketType.seats.toModelArray();
    const generalAdmissions = ticketType.generalAdmissions.toModelArray();

    ticketType.delete();

    seats.forEach((seat) => {
        const loadedSeat = Seat.withId(seat.id);

        loadedSeat.compiled = {
            ...loadedSeat.compiled,
            ...resolveSeatColors(loadedSeat),
        };
    });

    generalAdmissions.forEach((generalAdmission) => {
        const loadedGeneralAdmission = GeneralAdmission.withId(generalAdmission.id);

        const { generalAdmissionConfig: { fill } } = getClosestConfigurationFromGeneralAdmission(
            loadedGeneralAdmission,
            'generalAdmissionConfig',
        );

        let objectFill = fill ?? GENERAL_ADMISSION_FILL;

        loadedGeneralAdmission.compiled = {
            ...loadedGeneralAdmission.compiled,
            objectFill,
        };
    });
};
